import { getWeekNumber } from "./Common";
export  const validarSemana = (semana,w) =>{
    if(!w) w = getWeekNumber();
    if(((semana??'')+'').length <= 3) return [false,semana];
    if(((semana??'')+'').length >4)semana = semana.substring(0,4);
    let numberSemana = parseInt(semana);
    let actual =`${w[0]-2000}${w[1] < 10? "0"+w[1]:w[1]}`;
    if(isNaN(numberSemana)) return [false,actual];
    let semanaS = parseInt(((semana??'')+'').substring(2,4));
    let anio = parseInt(((semana??'')+'').substring(0,2));
    if(isNaN(anio) || anio < 23) anio = '23';
    else anio = `${anio}`;
    if(semanaS > 52) semanaS = anio+'52';
    else if(semanaS < 1) semanaS = anio+'01';
    else semanaS = anio+`${semanaS >=10? semanaS:'0'+semanaS}`;
    return [true,semanaS];
}